import { render, staticRenderFns } from "./OtherFamilyDetails.vue?vue&type=template&id=6c4baf27&scoped=true&"
import script from "./OtherFamilyDetails.vue?vue&type=script&lang=js&"
export * from "./OtherFamilyDetails.vue?vue&type=script&lang=js&"
import style0 from "./OtherFamilyDetails.vue?vue&type=style&index=0&id=6c4baf27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4baf27",
  null
  
)

export default component.exports